import Swal from "sweetalert2";
import styled from 'styled-components';
import { Spinner } from 'react-bootstrap';
import { NavLink } from "react-router-dom";
import DeleteIcon from 'mdi-react/DeleteIcon';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { MissionProviderRoleEnum } from '../../../../../Enums';
import { paddingLeft, paddingRight } from '@/utils/directions';
import ReactTableBase from '@/shared/components/table/ReactTableBase';
import { colorAdditional, colorGreenHover, colorAccent } from '@/utils/palette';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';

const CartTableButton = styled.button`
  background: transparent;
  border: none;
  line-height: 14px;
  ${paddingLeft}: 20px;
  ${paddingRight}: 0;
  padding-top: 0;
  padding-bottom: 0;
  position: relative;
  color: ${colorAdditional};
  cursor: pointer;
  transition: all 0.3s;

  svg {
    height: 20px;
    width: 20px;
    fill: ${colorAdditional};
    transition: all 0.3s;
  }

  &:hover {
    color: ${colorGreenHover};

    svg {
      fill: ${colorGreenHover};
    }
  }
`;

const TableSpinner = styled(Spinner)`
  color: ${colorAccent};
`;

const MissionProvidersForm = (props) => {
  const [licenses, setLicenses] = useState();
  const [providers, setProviders] = useState();
  const [showLoader, setShowLoader] = useState(true);
  const [missionprovidersList, setMissionprovidersList] = useState({ tableHeaderData: [], tableRowsData: [] });
  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: false,
    withPagination: false,
    withSearchEngine: false
  };

  const handleDelete = (missionProvider) => {
    AdminInterface.instance.deleteMissionProvider(missionProvider).then(() => {
      withReactContent(Swal).fire({
        title: "Success",
        html: "Mission provider is deleted!",
      });
      props.setReloadMission(true);
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: [error.response?.data?.detail.map((detail) => detail.msg)],
      });
    });
  }

  const setTableData = (providersData) => {
    setShowLoader(true);
    const columns = [
      {
        accessor: 'provider',
        Header: 'Provider',
      },
      {
        accessor: 'role',
        Header: 'Role',
      },
      {
        accessor: 'license',
        Header: 'License',
      },
      {
        accessor: 'delete',
        Header: 'Delete',
        disableGlobalFilter: true,
        disableSortBy: true,
      }
    ];

    const data = [];
    providersData.forEach((missionProvider, index) => {
      data.push({
        provider: providers.find(provider => provider.id === missionProvider.providerId)?.name,
        role: Object.keys(MissionProviderRoleEnum).find(key => MissionProviderRoleEnum[key] === missionProvider.role),
        license: licenses.find(license => license.id === missionProvider.licenseId)?.name,
        delete: <CartTableButton type="button" onClick={() => handleDelete(missionProvider)}><DeleteIcon /></CartTableButton>,
      });
    });

    setMissionprovidersList({ tableHeaderData: columns, tableRowsData: data });
    setShowLoader(false);
  }

  const getProviders = () => {
    AdminInterface.instance.getProviders().then((response) => {
      setProviders(response.data)
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: error.response?.data?.detail,
      });
    });
  }

  const getLicenses = () => {
    AdminInterface.instance.getLicenses().then((response) => {
      setLicenses(response.data)
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: error.response?.data?.detail,
      });
    });
  }

  useEffect(() => {
    if (props.providersData == undefined) return;
    getProviders();
  }, [props.providersData]);

  useEffect(() => {
    if (providers == undefined) return;
    getLicenses();
  }, [providers]);

  useEffect(() => {
    if (licenses == undefined) return;
    setTableData(props.providersData);
  }, [licenses]);

  return (
    <>
      <CardTitleWrap>
        <CardTitle>Providers List</CardTitle>
      </CardTitleWrap>
      <NavLink to={{ pathname: "/assets/missions/providers", state: props.missionId }}><Button size="sm" variant="primary" >Add Provider</Button></NavLink>
      {
        !showLoader &&
        <ReactTableBase columns={missionprovidersList.tableHeaderData} data={missionprovidersList.tableRowsData} tableConfig={tableConfig} />
      }
      {showLoader && (<div className="text-center"><TableSpinner animation="border" /></div>)}
    </>
  );
};

export default MissionProvidersForm;